import React, { memo } from 'react';
import TotalItem from './Totaltem';
import TotalHead from './TotalHead';
import TotalSummary from './TotalSummary';
import { getSymbolsOptions } from '../utils';

const InventoryTotalView = memo((props) => {
  const {
    currentInventory,
    items,
    statuses,
    onRemoveItem,
    handleChangeSymbol,
    handleDuplicateItem,
    handleDuplicateCustomItem,
    handleChangeCF,
  } = props;

  const symbols = getSymbolsOptions(statuses);

  return (
    <div className="new-table inventory-total">
      <TotalHead />

      <div className="inventory-items">
        {items.map((item, index) => (
          <TotalItem
            onRemoveItem={() => onRemoveItem(index)}
            handleChangeCF={(e) => handleChangeCF(e, index)}
            onChangeSymbol={(value, position) => handleChangeSymbol(value, position, index)}
            onDuplicate={() => {
              const isCustom = item.custom === 1 || currentInventory?.find((el) => el.id === item.inventory_id) == null;

              if (isCustom) handleDuplicateCustomItem(item);
              else handleDuplicateItem(item.inventory_id);
            }}
            symbols={symbols}
            item={item}
            key={index}
          />
        ))}
      </div>

      <TotalSummary items={items} />
    </div>
  );
});

export default InventoryTotalView;
